import { api } from '@/api';

export interface RoleApiModel {
  uuid: string;
  role_name: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface RolesListPayload {
  count: number;
  next: string | null;
  previous: string | null;
  results: RoleApiModel[];
}

export const rolesService = {
  async list(page: number = 1, pageSize: number = 15, search?: string): Promise<RolesListPayload> {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
    });
    
    if (search && search.trim()) {
      params.append('search', search.trim());
    }
    
    const response = await api.get<RolesListPayload>(`/backoffice/api/v1/roles/?${params.toString()}`);
    // The API returns data directly, not wrapped in ApiResponse
    return response as unknown as RolesListPayload;
  },
  async create(payload: { role_name: string }): Promise<unknown> {
    return api.post<unknown>('/backoffice/api/v1/roles/', payload);
  },
  async update(uuid: string, payload: { role_name: string }): Promise<unknown> {
    return api.put<unknown>(`/backoffice/api/v1/role/${uuid}/`, payload);
  },
  async toggleActive(uuid: string, is_active: boolean): Promise<unknown> {
    return api.put<unknown>(`/backoffice/api/v1/role/${uuid}/`, { is_active: is_active });
  },
  async delete(uuid: string): Promise<unknown> {
    return api.delete<unknown>(`/backoffice/api/v1/role/${uuid}/`);
  },
};

export default rolesService;


